import type { SVGProps } from 'react'

const EyeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={14}
    fill="none"
    viewBox="0 0 20 12"
    {...props}
  >
    <path
      stroke="#1867FF"
      strokeWidth={2}
      d="M1.031 6.638A11.307 11.307 0 0 1 .587 6c.099-.155.247-.375.444-.638a13.748 13.748 0 0 1 1.818-1.99C4.46 1.925 6.848.5 10 .5c3.152 0 5.539 1.425 7.151 2.872a13.751 13.751 0 0 1 1.818 1.99c.197.263.345.483.444.638-.099.155-.247.375-.444.638a13.751 13.751 0 0 1-1.818 1.99C15.54 10.075 13.152 11.5 10 11.5c-3.152 0-5.539-1.425-7.151-2.872a13.748 13.748 0 0 1-1.818-1.99Z"
    />
    <circle
      cx={10}
      cy={6}
      r={5.5}
      stroke="#1867FF"
      strokeWidth={2}
    />
    <circle
      cx={10}
      cy={6}
      r={1.5}
      fill="#1867FF"
      stroke="#1867FF"
      strokeWidth={2}
    />
  </svg>
)
export default EyeIcon
